import React, { useEffect, useState } from "react";
import CalendarImg from "../../../assets/calendar.png";

const BlogItem = ({ link, title, image, description, date }) => {
  const [desc, setDesc] = useState("");
  const [strDate, setStrDate] = useState("");

  useEffect(() => {
    const trim = description.search("</figure><p>");
    setDesc(description.substr(trim + 12, 125) + "...");

    const timedate = new Date(date);

    let dateArr = timedate.toDateString().split(" ");
    setStrDate(`${dateArr[1]} ${dateArr[2]}, ${dateArr[3]}`);
  }, []);
  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      className="blog-card relative block overflow-hidden rounded-sm"
    >
      {image?.trim() ? (
        <img
          src={image}
          alt=""
          className="blog-thumb pointer-events-none absolute inset-0 z-0 h-full w-full object-cover opacity-0 transition-opacity duration-500 ease-in-out"
        />
      ) : null}
      <div className="relative z-10">
        <h1 className="mb-2 text-xl font-semibold capitalize text-N90">
          {title}
        </h1>
        <p className="mb-4 text-N70">{desc}</p>
        <div className="flex items-center gap-4 text-sm capitalize text-N50">
          <img src={CalendarImg} alt="" className="w-5" />
          <span>{strDate}</span>
        </div>
      </div>
    </a>
  );
};

export default BlogItem;
